import React, {memo} from 'react'

import KeyboardArrowLeftRoundedIcon from '@material-ui/icons/KeyboardArrowLeftRounded';
import KeyboardArrowRightRoundedIcon from '@material-ui/icons/KeyboardArrowRightRounded';
import KeyboardArrowUpRoundedIcon from '@material-ui/icons/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';

import './SideBarButton.css'

export default memo((props) => {

  const _handleButtonClick = (e) => {
    e.preventDefault()
    props.handleButtonClick()
  }

  const fullButton = props.fullButton
  const buttonExtraClass = fullButton ? "sidebar-button-full" : "sidebar-button-part"
  const partlyCollapsed = props.collapsed === "partlyCollapsed"
  const arrow = fullButton && !partlyCollapsed
    ? <KeyboardArrowRightRoundedIcon key="arrow"/>
    : !fullButton && !partlyCollapsed
      ? <KeyboardArrowUpRoundedIcon key="arrow"/>
      : !fullButton && partlyCollapsed
        ? <KeyboardArrowLeftRoundedIcon key="arrow"/>
        : <KeyboardArrowDownRoundedIcon key="arrow"/>
  const buttonContent = fullButton 
    ? [<span key="fullTextSpan" >{props.fullText}</span>, arrow]
    : [<span key="smallTextSpan">{props.smallText}</span>, arrow]
  
  return (
      <div className={"sidebar-button " + buttonExtraClass} onClick={_handleButtonClick}>
        {
          buttonContent
        }
      </div>
  )

})